import React from 'react'
import './styles.scss'
import { get } from 'lodash'
import VideoJSPlayer from '~/components/VideoPlayer'
import { getLocalizedVal } from '~/tools/localization/helpers';
import { getShowSeasonEpisodeHeader, getShowSeasonNextEpisodeHeader } from './helpers';
import WorkoutOverlay from './workoutOverlay';

class WorkoutEpisodeOverlay extends React.Component {
	state = {
		curStage: 'circuit_start',
		player: null
	}

	videoEndedHandler = () => {
		if(this.state.player && this.state.player.isFullscreen()){
			this.state.player.exitFullscreen();
		}
		this.setState({
			curStage: 'circuit_end'
		})
	}

	stageChangeHandler = (stage) => {
		this.setState({
			curStage: stage
		}, ()=>{
			if(stage === 'circuit_start') this.state.player.play();
		})
	}

	getVideoRef = (player) => {
		this.setState({player});
	}

	playNextCircuit = (video) => {
		this.setState({
			curStage: 'circuit_start'
		}, ()=>video.autoplayNextEpisode());
	}

	initialCustomStyle(){
		this.props.updateCustomStyle({
			"background-color": "initial",
			"background": "rgba(0, 0, 0, 0.9)",
			"display": "flex",
			"align-items": "center",
			"justify-content": "center",
		});
	}

	componentDidMount(){
		this.initialCustomStyle();
	}
	
	render(){

		const { video, metadataMap } = this.props.args;
		const { curStage } = this.state;
		const displayWorkoutOverlay = !(curStage === 'circuit_start') ? ' hide-control-panel' : '';
	
		return (
			<div className={`workout-overlay-player${displayWorkoutOverlay}`}>
				<VideoJSPlayer
					{...this.props.args}
					fileType={video.fileType}
					isEpisode={true}
					overlay={true}
					videoId={video.gist.id}
					user={this.props.user}
					isFree={video.gist.free}
					autoplay={window.settings.features["auto_play"]}
					videoTag={get(window.settings, "advertising.videoTag")}
					startTime={video.watchedTime}
					videoEndedHandler={this.videoEndedHandler.bind(this)}
					disableNextEpisodeTimer={true}
					getVideoRef={this.getVideoRef.bind(this)}
				/>
				<div className="overlay-episode-details">
					<div className="episode-name">
						<span className="season-episode-details">
							{getShowSeasonEpisodeHeader(video)}
						</span>
					</div>
					{video.nextEpisode &&
						video.nextEpisode.contentType !== "SEASON_PASS" && (
							<div
								className="next-episode"
								onClick={() => this.playNextCircuit(video)}
							>
								<div className="next-episode-img">
									<div
										className="image"
										style={{
											backgroundImage: `url(${video.nextEpisode.gist.videoImageUrl}?impolicy=resize&w=76&h=44)`
										}}
									></div>
								</div>
								<div className="next-episode-title-container">
									<p className="next-copy">
										{getLocalizedVal(
											window.settings,
											"genericMessages",
											"nextLabel"
										)}
									</p>
									<p className="next-episode-title">
										{getShowSeasonNextEpisodeHeader(video)}
									</p>
								</div>
							</div>
						)}
				</div>
				{displayWorkoutOverlay && (
					<WorkoutOverlay
						curStage={curStage}
						stageChangeHandler={this.stageChangeHandler}
						video={video}
						playNextCircuit={this.playNextCircuit}
						metadataMap={metadataMap}
					/>
				)}
			</div>
		);
	}
}

export default WorkoutEpisodeOverlay;